import Richtext from '@tmh-website/components/shared/Richtext';
import StyledTypo from '@tmh-website/styles/typo';
import styled from 'styled-components';

export const Headline = styled(StyledTypo.Typography)<{ $hasMarginAfterHeadline?: boolean }>`
  margin-top: 0.5em;
  margin-bottom: ${({ $hasMarginAfterHeadline }) => ($hasMarginAfterHeadline ? '0' : '')};
  &:first-child {
    margin-top: 0;
  }
`;

export const Text = styled(Richtext)``;

export const Container = styled.div<{ $textAlign?: 'left' | 'center' | 'right' }>`
  max-width: ${props => props.theme.smallSectionMaxWidth};
  margin: 0 auto;
  text-align: ${props => props.$textAlign ?? 'center'};
`;
